module.exports = __webpack_public_path__ + "img/tet20204.90cf04ae.png";